import { useState } from "react";

export default function StepPaymentDelivery({ onNext, onBack, formData }) {
  const [name, setName] = useState(formData.name || "");
  const [email, setEmail] = useState(formData.email || "");
  const [phone, setPhone] = useState(formData.phone || "");

  return (
    <div>
      <h2 className="text-xl font-semibold mb-2">Payment & Delivery Info</h2>
      <input
        className="w-full p-2 border rounded mb-2"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder="Name"
      />
      <input
        className="w-full p-2 border rounded mb-2"
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder="Email"
        type="email"
      />
      <input
        className="w-full p-2 border rounded mb-2"
        value={phone}
        onChange={e => setPhone(e.target.value)}
        placeholder="Phone"
        type="tel"
      />
      <div className="flex gap-2 mt-4">
        <button className="btn btn-secondary" onClick={onBack}>Back</button>
        <button
          className="btn btn-primary"
          disabled={!name || !email}
          onClick={() => onNext({ name, email, phone })}
        >
          Next
        </button>
      </div>
    </div>
  );
}